// Event Progression PDF Generator - Atelier 3 Activit\u00e9 5
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const STRINGS = {
  fr: {
    metaTitle: 'Rapport Atelier 3 - Progression des \u00c9v\u00e9nements',
    metaSubject: 'EBIOS RM - Atelier 3 - Activit\u00e9 5 - Progression des \u00c9v\u00e9nements',
    metaAuthor: 'Syst\u00e8me EBIOS RM',
    metaKeywords: 'EBIOS RM, Atelier 3, Progression, Risques, \u00c9v\u00e9nements',
    defaultAnalysisName: 'Analyse EBIOS RM',
    defaultOrg: 'Organisation',
    reference: 'EBIOSRM_ATELIER3_ACT5',
    defaultAuthor: 'Syst\u00e8me EBIOS RM',
    locale: 'fr-FR',
    status: 'Finalis\u00e9',
    reportType: 'Atelier 3 - Activit\u00e9 5 - Progression des \u00c9v\u00e9nements',
    programLabel: 'Programme :',
    programValue: 'Analyse des risques \u2013 EBIOS RM',
    internal: 'Interne',
    documentLabel: 'Document :',
    docTypeValue: 'Rapport Atelier 3 - Progression des \u00c9v\u00e9nements',
    versionLabel: 'Version :',
    refLabel: 'R\u00e9f :',
    reportHeading: "Rapport d'Analyse de Risques:",
    fallbackScope: 'Atelier 3',
    ebiosTitle: 'EBIOS RM - Atelier 3',
    coverSubtitle: 'Activit\u00e9 5 - Progression des \u00c9v\u00e9nements',
    infoProgramLabel: 'Programme',
    infoProgramValue: 'Atelier 3 - Activit\u00e9 5 - Progression des \u00c9v\u00e9nements',
    infoOrgLabel: 'Organisation',
    notSpecified: 'Non sp\u00e9cifi\u00e9',
    classificationLabel: 'Classification',
    revisionFreqLabel: 'Fr\u00e9quence de r\u00e9vision',
    revisionFreqValue: 'Annuelle / chaque changement majeur',
    statusLabel: 'Statut',
    statusValue: 'Compl\u00e9t\u00e9',
    genDateLabel: 'Date de g\u00e9n\u00e9ration',
    historyHeaders: ['Version', 'Date', 'Description, remarques', 'Auteur', 'V\u00e9rificateur', 'Approbateur'],
    initialEntry: 'Rapport initial Progression des \u00c9v\u00e9nements',
    footerMethodo: 'M\u00e9thodologie EBIOS RM - Atelier 3: Progression des \u00c9v\u00e9nements',
    footerConfidential: 'Document confidentiel - Usage interne uniquement',
    pageHeader: 'Rapport Atelier 3 - Progression des \u00c9v\u00e9nements',
    pageSectionName: 'Progression des \u00c9v\u00e9nements',
    pageFooterLeft: 'Rapport EBIOS RM',
    pageFooterCenter: 'Confidentiel - Usage interne',
    statsTitle: 'STATISTIQUES GLOBALES',
    rowTotal: 'Total \u00c9v\u00e9nements',
    rowEnriched: '\u00c9v\u00e9nements Enrichis',
    rowPartial: '\u00c9v\u00e9nements Partiellement Trait\u00e9s',
    rowNotTreated: '\u00c9v\u00e9nements Non Trait\u00e9s',
    rowCoverage: 'Taux de Couverture Global',
    rowA1: 'Total Mesures Atelier 1',
    rowA3: 'Total Mesures Atelier 3',
    rowProgression: 'Progression Moyenne',
    statsHead: [['M\u00e9trique', 'Valeur']],
    detailsTitle: 'D\u00c9TAILS DE PROGRESSION DES \u00c9V\u00c9NEMENTS',
    noEvents: 'Aucun \u00e9v\u00e9nement trouv\u00e9.',
    undefinedBV: 'Non d\u00e9fini',
    stEnriched: 'Enrichi',
    stPartial: 'Partiellement Trait\u00e9',
    stNotTreated: 'Non Trait\u00e9',
    noAssets: 'Aucun',
    tableHead: [['\u00c9v\u00e9nement Redout\u00e9', 'Valeur M\u00e9tier', 'Biens Supports', 'Mesures A1', 'Mesures A3', 'Progression', 'Statut']],
    defaultSaveName: 'rapport-progression-evenements.pdf',
  },
  en: {
    metaTitle: 'Workshop 3 Report - Event Progression',
    metaSubject: 'EBIOS RM - Workshop 3 - Activity 5 - Event Progression',
    metaAuthor: 'EBIOS RM System',
    metaKeywords: 'EBIOS RM, Workshop 3, Progression, Risks, Events',
    defaultAnalysisName: 'EBIOS RM Analysis',
    defaultOrg: 'Organization',
    reference: 'EBIOSRM_WORKSHOP3_ACT5',
    defaultAuthor: 'EBIOS RM System',
    locale: 'en-GB',
    status: 'Finalized',
    reportType: 'Workshop 3 - Activity 5 - Event Progression',
    programLabel: 'Program:',
    programValue: 'Risk Analysis \u2013 EBIOS RM',
    internal: 'Internal',
    documentLabel: 'Document:',
    docTypeValue: 'Workshop 3 Report - Event Progression',
    versionLabel: 'Version:',
    refLabel: 'Ref:',
    reportHeading: 'Risk Analysis Report:',
    fallbackScope: 'Workshop 3',
    ebiosTitle: 'EBIOS RM - Workshop 3',
    coverSubtitle: 'Activity 5 - Event Progression',
    infoProgramLabel: 'Program',
    infoProgramValue: 'Workshop 3 - Activity 5 - Event Progression',
    infoOrgLabel: 'Organization',
    notSpecified: 'Not specified',
    classificationLabel: 'Classification',
    revisionFreqLabel: 'Revision Frequency',
    revisionFreqValue: 'Annual / Every major change',
    statusLabel: 'Status',
    statusValue: 'Completed',
    genDateLabel: 'Generation Date',
    historyHeaders: ['Version', 'Date', 'Description, notes', 'Author', 'Reviewer', 'Approver'],
    initialEntry: 'Initial Event Progression Report',
    footerMethodo: 'EBIOS RM Methodology - Workshop 3: Event Progression',
    footerConfidential: 'Confidential Document - Internal Use Only',
    pageHeader: 'Workshop 3 Report - Event Progression',
    pageSectionName: 'Event Progression',
    pageFooterLeft: 'EBIOS RM Report',
    pageFooterCenter: 'Confidential - Internal Use',
    statsTitle: 'GLOBAL STATISTICS',
    rowTotal: 'Total Events',
    rowEnriched: 'Enriched Events',
    rowPartial: 'Partially Treated Events',
    rowNotTreated: 'Not Treated Events',
    rowCoverage: 'Global Treatment Rate',
    rowA1: 'Total Workshop 1 Measures',
    rowA3: 'Total Workshop 3 Measures',
    rowProgression: 'Average Progression Rate',
    statsHead: [['Metric', 'Value']],
    detailsTitle: 'EVENT PROGRESSION DETAILS',
    noEvents: 'No events found.',
    undefinedBV: 'Not defined',
    stEnriched: 'Enriched',
    stPartial: 'Partially Treated',
    stNotTreated: 'Not Treated',
    noAssets: 'None',
    tableHead: [['Feared Event', 'Business Value', 'Support Assets', 'A1 Measures', 'A3 Measures', 'Progression', 'Status']],
    defaultSaveName: 'event-progression-report.pdf',
  },
};

class EventProgressionPdfGenerator {
    constructor(reportData, analysisData = {}, lang = 'fr') {
        this.reportData = reportData || {};
        this.analysisData = analysisData || {};
        this.lang = lang;
        this.T = STRINGS[lang] || STRINGS.fr;

        // Initialize jsPDF instance in Portrait mode for the cover page
        this.pdf = new jsPDF('p', 'mm', 'a4');

        // Set PDF metadata
        this.pdf.setProperties({
            title: this.T.metaTitle,
            subject: this.T.metaSubject,
            author: this.T.metaAuthor,
            creator: 'EBIOS RM Event Progression Report Generator',
            keywords: this.T.metaKeywords
        });

        // Set analysis metadata for cover page
        this.metadata = {
            analysisId: this.analysisData.id || this.reportData.analysisId,
            analysisName: this.analysisData.name || this.reportData.analysisName || this.T.defaultAnalysisName,
            companyName: this.analysisData.companyName || this.reportData.organizationName || this.T.defaultOrg,
            version: '1.0',
            reference: this.T.reference,
            createdBy: this.analysisData.createdBy || this.T.defaultAuthor,
            lastModified: new Date().toLocaleDateString(this.T.locale),
            status: this.T.status,
            reportType: this.T.reportType
        };
    }

    /**
     * Generate Atelier 3 Activity 5 cover page
     * Matches layout of Ecosystem Report (Atelier 3 Activity 1)
     */
    generateCoverPage() {
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        const pageHeight = this.pdf.internal.pageSize.getHeight();

        // Clean white background
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(0, 0, pageWidth, pageHeight, 'F');

        // Header table - Programme info
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.setDrawColor(0, 0, 0);
        this.pdf.setLineWidth(0.5);
        this.pdf.rect(15, 15, 180, 10, 'S');

        this.pdf.setFontSize(9);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.programLabel, 17, 21);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.T.programValue, 45, 21);

        // Internal classification label
        this.pdf.setFillColor(200, 200, 200);
        this.pdf.rect(135, 15, 60, 10, 'FD');
        this.pdf.setTextColor(0, 0, 0);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.internal, 155, 21);
        this.pdf.setTextColor(0, 0, 0);

        // Document type
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(15, 25, 180, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.documentLabel, 17, 30);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.T.docTypeValue, 45, 30);

        // Version and Reference
        this.pdf.rect(15, 33, 90, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.versionLabel, 17, 38);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.metadata.version || '1.0', 37, 38);

        this.pdf.rect(105, 33, 90, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.refLabel, 107, 38);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.metadata.reference || this.T.reference, 120, 38);

        // Main title
        this.pdf.setFontSize(18);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.setTextColor(37, 99, 235);
        this.pdf.text(this.T.reportHeading, 105, 65, { align: 'center' });

        this.pdf.setFontSize(18);
        const analysisName = this.reportData.analysisName || this.metadata.companyName || this.T.fallbackScope;
        const maxTW = this.pdf.internal.pageSize.getWidth() - 30;
        const al = this.pdf.splitTextToSize(analysisName, maxTW);
        al.forEach((line, i) => this.pdf.text(line, 105, 80 + i * 7, { align: 'center' }));
        const extraY = (al.length - 1) * 7;

        // EBIOS RM title
        this.pdf.setFontSize(22);
        this.pdf.setTextColor(37, 99, 235);
        this.pdf.text(this.T.ebiosTitle, 105, 105 + extraY, { align: 'center' });

        this.pdf.setFontSize(16);
        this.pdf.text(this.T.coverSubtitle, 105, 115 + extraY, { align: 'center' });
        this.pdf.setTextColor(0, 0, 0);

        // Information table
        const tableStartY = 135 + extraY;
        const rowHeight = 8;

        const tableData = [
            [this.T.infoProgramLabel, this.T.infoProgramValue],
            [this.T.infoOrgLabel, this.metadata.companyName || this.T.notSpecified],
            [this.T.classificationLabel, this.T.internal],
            [this.T.revisionFreqLabel, this.T.revisionFreqValue],
            [this.T.statusLabel, this.T.statusValue],
            [this.T.genDateLabel, new Date().toLocaleDateString(this.T.locale)]
        ];

        tableData.forEach((row, index) => {
            const y = tableStartY + (index * rowHeight);

            // Label column (blue background)
            this.pdf.setFillColor(41, 82, 163);
            this.pdf.rect(15, y, 65, rowHeight, 'FD');
            this.pdf.setTextColor(255, 255, 255);
            this.pdf.setFontSize(9);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text(row[0], 17, y + 5.5);

            // Value column (light gray background)
            this.pdf.setFillColor(235, 235, 235);
            this.pdf.rect(80, y, 115, rowHeight, 'FD');
            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFont('helvetica', 'normal');

            // Handle long text
            const maxWidth = 110;
            const lines = this.pdf.splitTextToSize(row[1], maxWidth);
            if (lines.length > 1) {
                const truncated = row[1].length > 50 ? row[1].substring(0, 47) + '...' : row[1];
                this.pdf.text(truncated, 82, y + 5.5);
            } else {
                this.pdf.text(row[1], 82, y + 5.5);
            }
        });

        // Version history table
        const historyY = 200;
        const headerHeight = 10;
        const dataRowHeight = 15;

        const headers = this.T.historyHeaders;
        const colWidths = [18, 22, 70, 30, 20, 20];
        let xPos = 15;

        // Draw header row
        headers.forEach((header, i) => {
            this.pdf.setFillColor(41, 82, 163);
            this.pdf.setDrawColor(0, 0, 0);
            this.pdf.setLineWidth(0.5);
            this.pdf.rect(xPos, historyY, colWidths[i], headerHeight, 'FD');

            this.pdf.setTextColor(255, 255, 255);
            this.pdf.setFontSize(7);
            this.pdf.setFont('helvetica', 'bold');

            const maxHeaderWidth = colWidths[i] - 3;
            const headerLines = this.pdf.splitTextToSize(header, maxHeaderWidth);
            const startY = historyY + (headerHeight / 2) - ((headerLines.length - 1) * 1.5);

            headerLines.forEach((line, lineIndex) => {
                this.pdf.text(line, xPos + 1.5, startY + (lineIndex * 3));
            });

            xPos += colWidths[i];
        });

        // Add data row
        xPos = 15;
        const versionData = [
            this.metadata.version || '1.0',
            new Date().toLocaleDateString(this.T.locale),
            this.T.initialEntry,
            this.metadata.createdBy || this.T.defaultAuthor,
            '',
            ''
        ];

        versionData.forEach((data, i) => {
            this.pdf.setFillColor(245, 245, 245);
            this.pdf.setDrawColor(0, 0, 0);
            this.pdf.setLineWidth(0.5);
            this.pdf.rect(xPos, historyY + headerHeight, colWidths[i], dataRowHeight, 'FD');

            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFontSize(7);
            this.pdf.setFont('helvetica', 'normal');

            if (data) {
                const maxColWidth = colWidths[i] - 3;
                const lines = this.pdf.splitTextToSize(data, maxColWidth);
                const maxLines = Math.floor((dataRowHeight - 2) / 3);
                const displayLines = lines.slice(0, maxLines);

                if (lines.length > maxLines && displayLines.length > 0) {
                    let truncatedLine = displayLines[displayLines.length - 1];
                    const ellipsisWidth = this.pdf.getTextWidth('...');
                    const availableWidth = maxColWidth - ellipsisWidth;

                    while (this.pdf.getTextWidth(truncatedLine) > availableWidth && truncatedLine.length > 0) {
                        truncatedLine = truncatedLine.slice(0, -1);
                    }
                    displayLines[displayLines.length - 1] = truncatedLine + '...';
                }

                const startY = historyY + headerHeight + (dataRowHeight / 2) - ((displayLines.length - 1) * 1.5);
                displayLines.forEach((line, lineIndex) => {
                    this.pdf.text(line, xPos + 1.5, startY + (lineIndex * 3));
                });
            }
            xPos += colWidths[i];
        });

        // Footer
        const footerY = pageHeight - 20;
        this.pdf.setFontSize(8);
        this.pdf.setTextColor(107, 114, 128);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.T.footerMethodo, 105, footerY, { align: 'center' });
        this.pdf.text(this.T.footerConfidential, 105, footerY + 8, { align: 'center' });
    }

    /**
     * Start new content page with clean background
     * @param {string} orientation - 'p' for portrait, 'l' for landscape
     */
    startNewPage(orientation = 'p') {
        this.pdf.addPage('a4', orientation);
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        const pageHeight = this.pdf.internal.pageSize.getHeight();

        // White background
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(0, 0, pageWidth, pageHeight, 'F');
    }

    /**
     * Add professional page headers and footers to all pages
     */
    addPageNumbers() {
        const pageCount = this.pdf.internal.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            this.pdf.setPage(i);
            const pageWidth = this.pdf.internal.pageSize.getWidth();
            const pageHeight = this.pdf.internal.pageSize.getHeight();


            if (i === 1) continue;

            // PAGE HEADER
            const headerY = 15;
            this.pdf.setDrawColor(229, 231, 235);
            this.pdf.setLineWidth(0.5);
            this.pdf.line(20, headerY + 5, pageWidth - 20, headerY + 5);

            this.pdf.setFontSize(8);
            this.pdf.setTextColor(107, 114, 128);
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text(this.T.pageHeader, 20, headerY);

            this.pdf.text(this.T.pageSectionName, pageWidth - 20, headerY, { align: 'right' });

            // PAGE FOOTER
            const footerY = pageHeight - 10;
            this.pdf.setDrawColor(229, 231, 235);
            this.pdf.setLineWidth(0.5);
            this.pdf.line(20, footerY - 5, pageWidth - 20, footerY - 5);

            this.pdf.setFontSize(8);
            this.pdf.setTextColor(107, 114, 128);
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text(this.T.pageFooterLeft, 20, footerY);

            const centerText = this.T.pageFooterCenter;
            this.pdf.text(centerText, pageWidth / 2, footerY, { align: 'center' });

            this.pdf.text(`Page ${i}`, pageWidth - 20, footerY, { align: 'right' });
        }
    }

    /**
     * Generate Global Statistics Page
     */
    generateGlobalStats() {
        const stats = this.reportData.globalStats || {};
        let currentY = 30;

        this.pdf.setFontSize(18);
        this.pdf.setTextColor(30, 64, 175);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.statsTitle, 20, currentY);
        currentY += 15;

        // Create a stats table
        const statsData = [
            [this.T.rowTotal, stats.totalEvents || 0],
            [this.T.rowEnriched, `${stats.enrichedEvents || 0} (${stats.enrichmentRate || 0}%)`],
            [this.T.rowPartial, stats.partiallyTreatedEvents || 0],
            [this.T.rowNotTreated, stats.notTreatedEvents || 0],
            [this.T.rowCoverage, `${stats.treatmentRate || 0}%`],
            [this.T.rowA1, stats.totalA1Measures || 0],
            [this.T.rowA3, stats.totalA3Measures || 0],
            [this.T.rowProgression, `${stats.averageProgressionRate || 0}%`]
        ];

        this.pdf.autoTable({
            startY: currentY,
            head: this.T.statsHead,
            body: statsData,
            theme: 'grid',
            headStyles: {
                fillColor: [30, 64, 175],
                textColor: [255, 255, 255],
                fontSize: 10,
                fontStyle: 'bold',
                halign: 'left'
            },
            styles: {
                fontSize: 10,
                cellPadding: 5
            },
            columnStyles: {
                0: { cellWidth: 100, fontStyle: 'bold' },
                1: { cellWidth: 50, halign: 'right' }
            },
            margin: { left: 20 }
        });
    }

    /**
     * Generate Event Progression Table
     */
    generateProgressionTable() {
        const events = this.reportData.eventProgression || [];
        let currentY = 30;

        this.pdf.setFontSize(18);
        this.pdf.setTextColor(30, 64, 175);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text(this.T.detailsTitle, 20, currentY);
        currentY += 15;

        if (events.length === 0) {
            this.pdf.setFontSize(12);
            this.pdf.setTextColor(100, 100, 100);
            this.pdf.text(this.T.noEvents, 20, currentY);
            return;
        }

        const tableBody = events.map(event => {
            // Format business value
            let businessValue = event.businessValueDetails?.name || this.T.undefinedBV;
            if (event.businessValueDetails?.shortId) {
                businessValue += ` [${event.businessValueDetails.shortId}]`;
            }

            // Format status
            let statusLabel = event.statusLabel || event.status;
            if (event.status === 'enriched') statusLabel = this.T.stEnriched;
            else if (event.status === 'partially-treated') statusLabel = this.T.stPartial;
            else if (event.status === 'not-treated') statusLabel = this.T.stNotTreated;

            return [
                `${event.name}\n(${event.gravity} • ${event.securityPillar})`,
                businessValue,
                event.supportAssetsFormatted || this.T.noAssets,
                event.a1Measures.length.toString(),
                event.a3Measures.length.toString(),
                `${event.progressionRate}%`,
                statusLabel
            ];
        });

        this.pdf.autoTable({
            startY: currentY,
            head: this.T.tableHead,
            body: tableBody,
            theme: 'grid',
            headStyles: {
                fillColor: [30, 64, 175],
                textColor: [255, 255, 255],
                fontSize: 9,
                fontStyle: 'bold',
                halign: 'center',
                valign: 'middle'
            },
            styles: {
                fontSize: 8,
                cellPadding: 3,
                lineColor: [200, 200, 200],
                lineWidth: 0.1,
                overflow: 'linebreak',
                valign: 'top'
            },
            columnStyles: {
                0: { cellWidth: 60, fontStyle: 'bold' }, // Event
                1: { cellWidth: 40 }, // Business Value
                2: { cellWidth: 40 }, // Support Assets
                3: { cellWidth: 20, halign: 'center' }, // A1
                4: { cellWidth: 20, halign: 'center' }, // A3
                5: { cellWidth: 25, halign: 'center' }, // Progression
                6: { cellWidth: 35, halign: 'center' }  // Status
            },
            alternateRowStyles: {
                fillColor: [245, 247, 250]
            },
            margin: { top: 20, bottom: 20, left: 10, right: 10 }
        });
    }

    /**
     * Generate complete report
     */
    async generateReport() {
        try {
            // Page 1: Cover (Portrait)
            this.generateCoverPage();

            // Page 2: Global Stats (Portrait)
            this.startNewPage('p');
            this.generateGlobalStats();

            // Page 3: Table (Landscape)
            this.startNewPage('l');
            this.generateProgressionTable();

            // Add common elements
            this.addPageNumbers();

            return this.pdf.output('blob');
        } catch (error) {
            console.error('Error generating PDF:', error);
            throw error;
        }
    }

    save(filename = null) {
        this.pdf.save(filename || this.T.defaultSaveName);
    }
}

export default EventProgressionPdfGenerator;
